import { Component, OnInit } from '@angular/core';
import { JReportPrinterService } from '../../services/jreport-printer.service';
@Component({
    selector: 'lfwms-jreport-print',
    templateUrl: './jreport-print.component.html',
    styleUrls: ['./jreport-print.component.css'],
  })
  export class JReportPrintComponent implements OnInit {
  public PrinterServiceData: any;
  public width;
  public height;
  public iframeUrl;
    constructor(printService: JReportPrinterService) {
        this.PrinterServiceData = printService.data;
    }
    public ngOnInit() {
        this.width = 1000;
        this.height = 600;
        if (this.PrinterServiceData) {
            this.iframeUrl = this.PrinterServiceData.iframeUrl;
        }
    }
  }


// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/jreport/jreport-print/jreport-print.component.ts